import http from '../utils/http';

/**
 * 通过账号密码登录
 * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#122
 *
 * @param {String} userName
 * @param {String} password md5后的密码
 * @returns Promise
 */

const loginApi = {

    login(options) {

        return http.post('/imageCodeLogin', options, {
                showLoading: '登录中...',
                errorMsg: false,
                needLogin: false,
            }
        );
    },

    imageCode(randomKey) {
        return http.get('/imageCode?randomKey=' + randomKey,{
            needLogin: false,
            responseType: 'blob'
        })
    }
}
export default loginApi;
